export default {
  pad: function (val, size) {
    return ('00000000' + val).substr(-size)
  },
  formatDate: function (date, limLength) {
    if (!date.getFullYear) date = new Date(date.replace(/-/g, '/'))
    let [ year, month, day, hour, min, sec ] = [ date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds() ]
    let strDate = this.pad(year, 4) + '-' + this.pad(month, 2) + '-' + this.pad(day, 2) + ' ' +
           this.pad(hour, 2) + ':' + this.pad(min, 2) + ':' + this.pad(sec, 2)
    return limLength ? strDate.substr(0, limLength) : strDate
  },
  formatUTCDate: function (date, limLength) {
    let [ year, month, day ] = [ date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate() ]
    let strDate = this.pad(year, 4) + '-' + this.pad(month, 2) + '-' + this.pad(day, 2)
    return limLength ? strDate.substr(0, limLength) : strDate
  },
  formatUTCDateTime: function (date, limLength) {
    let [ year, month, day, hour, min, sec ] = [ date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds() ]
    let strDate = this.pad(year, 4) + '-' + this.pad(month, 2) + '-' + this.pad(day, 2) + ' ' +
            this.pad(hour, 2) + ':' + this.pad(min, 2) + ':' + this.pad(sec, 2)
    return limLength ? strDate.substr(0, limLength) : strDate
  },
  genDate: function (date) {
    return date ? this.formatDate(date) : null
  },
  genDateUTC: function (date) {
    return date ? this.formatUTCDate(date) : null
  },
  genDateTimeUTC: function (date) {
    return date ? this.formatUTCDateTime(date) : null
  },
  calculDuration (dateStart, dateEnd) {
    let tmp = {
      durationYear: 0,
      durationMonth: 0,
      durationDay: 0,
      durationHour: 0,
      durationMin: 0,
      durationSec: 0
    }
    if (!dateStart || !dateEnd) {
      return tmp
    }
    tmp.durationYear = dateEnd.getUTCFullYear() - dateStart.getUTCFullYear()
    tmp.durationMonth = dateEnd.getUTCMonth() - dateStart.getUTCMonth()
    tmp.durationDay = Math.floor((dateEnd - dateStart) / 24 / 60 / 60 / 1000)
    tmp.durationHour = Math.abs(dateEnd.getUTCHours() - dateStart.getUTCHours())
    tmp.durationMin = Math.abs(dateEnd.getUTCMinutes() - dateStart.getUTCMinutes())
    tmp.durationSec = Math.abs(dateEnd.getUTCSeconds() - dateStart.getUTCSeconds())
    return tmp
  },
  initDateStart: function () {
    var dt = new Date()
    dt.setUTCDate(dt.getUTCDate() - 15)
    dt.setHours(0)
    dt.setMinutes(0)
    dt.setSeconds(0)
    return dt
  },
  initDateEnd: function (hourSet) {
    var dt = new Date()
    if (typeof hourSet === 'undefined') {
      dt.setHours(23)
      dt.setMinutes(59)
      dt.setSeconds(0)
    }
    // console.log('j initialise la date')
    // console.log(dt)
    // console.log('le hour set')
    // console.log(hourSet)
    return dt
  }
}
